import { useAutoComplete } from "components/hooks/useAutoComplete";
import { useDebouncedValue } from "components/hooks/useDebouncedValue";
import AsyncAutoComplete from "components/shared/asyncAutoComplete";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { RECURRING } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";
import { makeQueryString } from "utils/utils";

export const FormSelectReccuringProjectContainer = ({
  value = "",
  handleChange,
  name,
  width = "100%",
  customStyles = {},
  defaultValue = {
    label: '',
    value: ''
  },
  isTriggerOption = false
}) => {
  const [status, setStatus] = useState("idle"); // 'idle' || 'loading' || 'error'
  const [options, setOptions] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState("");
  const debouncedSearchValue = useDebouncedValue(searchInputValue);
  const { isOpen, onHandleOpenChange } = useAutoComplete();
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });
  const selectedOptionRef = useRef(selectedOption);

  // payload => { pageNumber, limit, search }
  const fetchOptions = async (payload) => {
    setStatus("loading");
    try {
      const queryString = makeQueryString(RECURRING, payload);
      const { data } = await privateGet(queryString);
      const responseOptions = data.data.recurrings.map((item) => {
        const option = isTriggerOption ? { label: `${item?.startDate ? dayjs(item.startDate).format('MMM D') : ""} ${item.title}`, value: item._id } : { label: item.title, value: item._id };

        if (value && value === option.value) {
          setSelectedOption(option);
        }

        return option;
      });
      setOptions(responseOptions);
      setStatus("idle");
    } catch (error) {
      setStatus("error");
    }
  };

  const onSearchInputValueChange = (event, newInputValue) => {
    // here only string get
    setSearchInputValue(newInputValue);
  };

  const onSelectedOptionChange = (event, newValue) => {
    if (!newValue && !selectedOption?.value) return;
    if(!newValue) return

    // in this format: {label: '', value: ''}
    setSelectedOption(newValue);
    handleChange(name, newValue);
    selectedOptionRef.current = newValue;
    setSearchInputValue("");
  };

  const onHandleOpenOptionsListOpenChange = (value) => {

    if (value && selectedOption?.value) {
      setSelectedOption({ label: "", value: "" });
      handleChange(name, "");
    } else {
      setSelectedOption(selectedOptionRef.current);
      handleChange(name, selectedOptionRef.current?.value);
    }

    onHandleOpenChange(value);
  };


  useEffect(() => {
    fetchOptions({
      pageNumber: 1,
      limit: 10,
      search: debouncedSearchValue,
    });
  }, [debouncedSearchValue]);

  return (
    <AsyncAutoComplete
      width={width}
      onSelectedOptionChange={onSelectedOptionChange}
      isOpen={isOpen}
      customStyles={customStyles}
      placeholder="Enter a project"
      options={options}
      isLoading={status === "loading"}
      onHandleOpenChange={onHandleOpenOptionsListOpenChange}
      selectedOption={selectedOption}
      searchInputValue={searchInputValue}
      onSearchInputValueChange={onSearchInputValueChange}
      name={name}
      defaultValue={defaultValue}
    />
  );
};
